import Component from '@glimmer/component';

import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';

import or from 'rise-ui/helpers/or.js';

export default class UiPageTitleComponent extends Component {
  @service uiPages;

  @cached get page() {
    const { location, page } = this.args;
    return page || location && this.uiPages.get(location);
  }

  <template>
    {{#if (or this.page.value.title (has-block))~}}
      <h3 class="qa-ui-page-title c-page-title qa-page-title">
        {{~#if this.page.value.title~}}
          {{this.page.value.title}}
        {{~else~}}
          {{yield}}
        {{~/if~}}
      </h3>
    {{~/if~}}
  </template>
}
